/* Small, customer-opened payment guidance. No automatic promotion or financing calculation. */
(() => {
  'use strict';
  if (window.DSPaymentMessaging) return;
  const eligible = () => window.DS_CRO?.country === 'US' && window.DS_CRO?.currency === 'USD';
  let dialog, opener;
  function brand() {
    const logo = document.createElement('img');
    logo.className = 'ds-payment-brand';
    logo.src = window.DS_CRO.paymentLogoUrl;
    logo.width = 64; logo.height = 26; logo.alt = 'Affirm';
    return logo.outerHTML;
  }
  function build() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.id = 'ds-payment-info-dialog';
    dialog.setAttribute('aria-labelledby', 'ds-payment-info-title');
    dialog.innerHTML = `<div class="ds-payment-sheet"><header><div><p class="ds-payment-sheet__eyebrow">PAY YOUR WAY</p>${brand()}</div><button type="button" class="ds-payment-sheet__close" data-ds-payment-close aria-label="Close payment information">×</button></header><h2 id="ds-payment-info-title" tabindex="-1">Your piece. Your payment options.</h2><p class="ds-payment-sheet__intro">Explore ways to pay over time for your Diamond Studio jewelry.</p><ol><li><strong>Find your piece.</strong><p>Choose your jewelry and options. Making an offer? The studio must accept it first.</p></li><li><strong>Choose Affirm at checkout.</strong><p>Review the available plans and complete Affirm’s eligibility check.</p></li><li><strong>See the terms before you decide.</strong><p>Affirm shows your rate, any down payment and payment schedule before you commit.</p></li></ol><p class="ds-payment-sheet__terms">Rates from 0–36% APR. Available to eligible U.S. customers paying in USD, subject to an eligibility check and approval. Options depend on your purchase amount, and a down payment may be required. Not all purchases or customers qualify for 0% APR. Payment options are provided by <a href="https://www.affirm.com/lenders" target="_blank" rel="noopener noreferrer">Affirm’s lending partners</a>. Your rate and payment schedule are shown before you commit.</p><footer><a href="https://www.affirm.com/how-it-works" target="_blank" rel="noopener noreferrer">Full details at Affirm <span aria-hidden="true">↗</span><span class="ds-payment-sr-only"> (opens in a new tab)</span></a><button type="button" class="ds-payment-sheet__done" data-ds-payment-close>Continue browsing</button></footer></div>`;
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-ds-payment-close]')) dialog.close();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ds-payment-sheet-open');
      if (opener?.isConnected) opener.focus({preventScroll: true});
    });
    document.body.append(dialog);
    return dialog;
  }
  function open(trigger) {
    if (!eligible()) return false;
    const sheet = build();
    if (sheet.open) return true;
    opener = trigger instanceof HTMLElement ? trigger : document.activeElement;
    sheet.showModal();
    document.documentElement.classList.add('ds-payment-sheet-open');
    sheet.querySelector('h2').focus({preventScroll: true});
    return true;
  }
  function cartReminder() {
    // Drawer contents are replaced after cart updates; insert exactly once per render.
    const footer = document.querySelector('#ds-cart-drawer .ds-bag-footer');
    const checkout = footer?.querySelector('[name="checkout"]');
    if (!checkout || footer.querySelector('[data-ds-payment-cart]')) return;
    const note = document.createElement('div');
    note.className = 'ds-payment-cart';
    note.dataset.dsPaymentCart = '';
    note.innerHTML = eligible()
      ? '<p>Choose ' + brand() + ' at checkout to explore payment options.</p><div class="ds-payment-cart__details"><small>Eligible U.S. customers · Subject to approval.</small><button type="button" class="ds-payment-info-link" data-ds-payment-info data-ds-payment-placement="cart_drawer" aria-haspopup="dialog" aria-controls="ds-payment-info-dialog">See how</button></div>'
      : '<p>Pay securely with PayPal at checkout.</p>';
    checkout.before(note);
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('[data-ds-payment-info]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (open(trigger)) event.preventDefault();
  });
  document.addEventListener('ds:bag-rendered', cartReminder);
  window.DSPaymentMessaging = {open};
  const init = () => { if (eligible()) build(); cartReminder(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
